import { useNavigate } from "react-router-dom"
import { useEffect, useState } from "react";
import api from "../../../api"
import LongestStreak from "./LongestStreak"

export default function ProfileSidebar() {
  const [profile, setProfile] = useState("");
  const [animatedXp, setAnimatedXp] = useState(() => {
    const saved = localStorage.getItem("previous_xp");
    return saved ? parseInt(saved) % 1250 : 0;
  });
  const [xpText, setXpText] = useState("");

  // fetch profile data
  useEffect(() => {
    api.get("profile/")
      .then((res) => {
        setProfile(res.data);
      })
      .catch((err) => {
        console.error("Error loading profile:", err);
      });
    }, []);

  // animated progress bar
  useEffect(() => {
    if (profile?.xp !== undefined) {
      const previousXp = localStorage.getItem("previous_xp")
        ? parseInt(localStorage.getItem("previous_xp"))
        : 0;
      const target = profile.xp % 1250;
      let current = previousXp % 1250;
  
      const diff = target - current;
      const steps = 20;
      const increment = diff / steps;
      let step = 0;

      const xpGain = profile.xp - previousXp;
      if (xpGain > 0) {
        setXpText(`${previousXp} + ${xpGain} xp`);
      } else {
        setXpText(`${profile.xp} xp`);
      };
  
      const animate = () => {
        step++;
        current += increment;
        setAnimatedXp(current);
  
        if (step < steps) {
          setTimeout(animate, 30);
        } else {
          setAnimatedXp(target);
          setXpText(`${profile.xp} xp`);
          localStorage.setItem("previous_xp", profile.xp); // ✅ Save new XP
        }
      };
  
      animate();

    }
  }, [profile?.xp]);


  console.log("current xp", profile.xp);

  // logout function
      const navigate = useNavigate();
    
      const handleLogout = () => {
        localStorage.removeItem('access');
        localStorage.removeItem('refresh');
        navigate('/');
      };

  return(
    <div>
      <div className="profileMain">
        
        {/* Profile picture */}
        <div className="flex mx-auto text-center my-4 w-40 h-40 rounded-full outline outline-3 outline-gray-400">
          <img
            src="/images/profile.png"
            alt="Profile"
            className="w-full h-full object-contain pt-4 pb-6"
          />
        </div>
        
        {/* ✅ XP Progress Bar */}
        <div className="relative w-[80%] h-8 items-center mx-auto">
          {/* Text on top of the full bar */}
          <div className="p-4 absolute inset-0 flex items-center text-sm font-major text-green-800 pointer-events-none">
            <span><strong>lVl {profile.level}</strong> · {xpText}</span>
          </div>

          {/* Background + border */}
          <div className="w-full h-full bg-green-100 rounded-2xl overflow-hidden shadow-inner border border-green-500">
            {/* Fill bar */}
            <div
              className="h-full bg-green-400 transition-all duration-500"
              style={{ width: `${animatedXp / 12.5}%` }}
            />
          </div>
        </div>

        <h2 className="text-2xl font-bold text-center mb-2">{profile.username}</h2>

        {/* Streakinfo */}
        <div className="mx-auto mb-4 p-4">
          <LongestStreak
            bestStreak={profile.best_streak}
          />
        </div>

        <div className="mt-8">
          <button
              onClick={handleLogout}
              className="buttonLogOut"
            >
              <div className="flex ml-auto gap-2">
                <span className="">log ud</span>
                <img
                    src="/images/logout.png"
                    alt="min side"
                    className="h-[0.9em] w-[0.9em] inline-block align-text-bottom relative top-[6px]"
                />
              </div>
          </button>
        </div>
      </div>
    </div>
  )
}